import React, { Component } from 'react';
import { Modal } from 'synfrastructure';
import Icon from '../../common/icons/Icon';
import numeral from 'numeral';

import plans from '../../common/plans';
import coachingPlans from '../../common/coaching-plans';
let combinedPlans = { ...plans, ...coachingPlans };

class UpgradeSubscriptionModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      selectedPlan: '',
    };
  }

  onChangePlan = key => {
    console.log('changing plan to', key);
    this.setState({ selectedPlan: combinedPlans[key].label });
  };

  toggleModal = () => {
    console.log('toggling the modal to ' + !this.state.modalOpen);
    this.setState({ modalOpen: !this.state.modalOpen });
  };

  getFormattedPrice = price => numeral(price / 100).format('$0,0.00');

  getTextForKey(key) {
    if (key === 'gold') {
      return (
        <div className="plan-text">
          In addition to your full online membership, enjoy personalized coaching from Bryan Hepler, the Founder of
          Tathata Golf. You will become one of his personal students and enjoy:<br />
          <br />
          12 swing submittals (1 per month)<br />
          12 online follow-up video calls (1 per month)<br />
          20% discount on all Tathata Golf products, schools, & training services.<br />
          <strong>$3,000 value if bought separately.</strong>
        </div>
      );
    } else {
      return (
        <div className="plan-text">
          In addition to your full Online Membership, enjoy personalized coaching from the Tathata Golf staff. This
          membership includes:<br />
          <br />
          12 swing submittals (1 per month)<br />
          12 online follow-up video calls(1 per month)<br />
          20% discount on all Tathata Golf products, schools, & training services.<br />
          <strong>$3,000 value if bought separately.</strong>
          <br />
          <br />
        </div>
      );
    }
  }

  render() {
    let plan = 'bronze';
    // let trialPeriodText = 'test';

    if (this.state.modalOpen) {
      return (
        <Modal
          isVisible
          onClose={this.toggleModal}
          closeButton={
            <button>
              <Icon icon="Close" />
            </button>
          }
        >
          <div>
            <div className="ms__request">
              <h4>Upgrade Membership</h4>
            </div>
            {/* <form> */}
            <div className="ms__request-form">
              <div className="plan-switcher__selector">
                {Object.keys(plans).map(key => (
                  <button
                    className={`plan-switcher__plan${plan === key ? ' active' : ''}`}
                    onClick={() => this.onChangePlan(key)}
                    key={key}
                  >
                    <div className="plan-title">
                      {/* <Icon icon={plan === key ? 'CheckBox' : 'CheckBoxOutline'} /> */}
                      {plans[key].label}
                      <br />
                    </div>
                    <div className="plan-subtext">{plans[key].subtext}&nbsp;</div>
                    <div className="plan-price">
                      {this.getFormattedPrice(plans[key].basePrice)}
                      <span className="period">
                        {' '}
                        {/* {discountDuration === 'once' ? `1st ${plans[key].period}` : plans[key].suffix} */}
                      </span>
                    </div>
                    {/* {this.getFormattedDiscountPrice(plans[key], discountDuration)} */}
                    {/* <div className="plan-info">
                      {plan === key ? trialPeriodText : <div className="plan-button">Select</div>}
                    </div> */}
                  </button>
                ))}
              </div>
              {/* <h3>Online Membership + Coaching Plans</h3> */}
              <div className="plan-switcher__selector">
                {Object.keys(coachingPlans).map(key => (
                  <button
                    className={`plan-switcher__plan${plan === key ? ' active' : ''}`}
                    onClick={() => this.onChangePlan(key)}
                    key={key}
                  >
                    <div className="plan-title">
                      {/* <Icon icon={plan === key ? 'CheckBox' : 'CheckBoxOutline'} /> */}
                      {coachingPlans[key].label}
                    </div>
                    <div className="plan-subtext">{coachingPlans[key].subtext}</div>
                    {this.getTextForKey(key)}
                    <div className="plan-price">
                      {this.getFormattedPrice(coachingPlans[key].basePrice)}
                      <span className="period">
                        {' '}
                        {/* {discountDuration === 'once' ? `1st ${coachingPlans[key].period}` : coachingPlans[key].suffix} */}
                      </span>
                    </div>
                    {/* {this.getFormattedDiscountPrice(coachingPlans[key], discountDuration)} */}
                    {/* <div className="plan-info">
                      {plan === key ? trialPeriodText : <div className="plan-button">Select</div>}
                    </div> */}
                  </button>
                ))}
              </div>
            </div>
            <div className="modal__actions">
              <button type="button" className="button button--theme--plain" onClick={this.toggleModal}>
                Cancel
              </button>
              <button
                type="submit"
                className="button"
                onClick={() =>
                  (window.location.href = `mailto:support@tathatagolf.com?subject=Upgrading my plan: ${this.state
                    .selectedPlan}`)}
              >
                Contact Support
              </button>
            </div>
            {/* </form> */}
          </div>
        </Modal>
      );
    } else {
      return (
        <div className="center-button">
          <button type="button" className="button button--center" onClick={this.toggleModal}>
            <span>Upgrade Your Membership</span>
          </button>
        </div>
      );
    }
  }
}

export default UpgradeSubscriptionModal;



// WEBPACK FOOTER //
// ./src/subscription/coaching/UpgradeSubscriptonModal.js